<div class="w-full overflow-hidden">
  <div class="w-full overflow-x-auto">
    <div
      [style.grid-template-columns]="'repeat(' + days().length + ', minmax(2.75rem, 1fr))'"
      class="grid min-w-full w-max pb-4">
      @for (day of days(); track day.toISOString()) {
        <div
          [class.border-l]="true"
          [class.border-r]="$last"
          class="py-2 text-center font-semibold cd-text-b6 border-b"
          style="border-color: var(--color-neutral-300)">
          {{ day.format('DD') }}
        </div>
      }

      @if (tasks.length) {
        @for (task of tasks; track task.id; let rowIndex = $index) {
          @for (day of days(); track day.toISOString()) {
            <div
              [style.grid-row]="getTaskRow(rowIndex)"
              [style.grid-column-start]="$index + 1"
              [style.grid-column-end]="$index + 2"
              [class.border-l]="true"
              [class.border-r]="$last"
              class="h-10"
              style="border-color: var(--color-neutral-300)"></div>
          }

          <div
            [style.grid-row]="getTaskRow(rowIndex)"
            [style.grid-column-start]="getStartColumn(task.startDate)"
            [style.grid-column-end]="getStartColumn(task.startDate) + getDurationDays(task.startDate, task.endDate)"
            [style.backgroundColor]="getTaskBackground(task.priority)"
            class="px-2 text-left font-regular cd-text-b2 h-8 whitespace-nowrap z-10 rounded-md self-center overflow-hidden text-ellipsis"
            >
            {{ task.name }}
          </div>
        }
      } @else {
        <div
          [style.grid-column-start]="1"
          [style.grid-column-end]="days().length + 1"
          class="h-12 flex items-center justify-center text-neutral-500 italic border-b border-l border-r"
          style="border-color: var(--color-neutral-300)">
          No hay tareas con fecha para mostrar en el diagrama.
        </div>
      }
    </div>
  </div>
</div>
